export default __webpack_public_path__ + "static/media/navigate-arrow.389c5480.svg";